module.exports = __webpack_public_path__ + "static/img/case-zg-page-bg-03.9dc96be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zg/case-zg-page-bg-03.jpg
// module id = Ga7g
// module chunks = 1